module.exports = __webpack_public_path__ + "static/media/SolutionsFirst.3e7640a6.png";